export default "__VITE_ASSET__Sjmq6G9P__"